module.exports = __webpack_public_path__ + "static/media/whyus1.e541093f.png";